module.exports = __webpack_public_path__ + "img/status-promotion.2b25a479.png";